import { render, staticRenderFns } from "./UserSearchResults.vue?vue&type=template&id=05d4a862&scoped=true"
import script from "./UserSearchResults.vue?vue&type=script&lang=ts"
export * from "./UserSearchResults.vue?vue&type=script&lang=ts"
import style0 from "./UserSearchResults.vue?vue&type=style&index=0&id=05d4a862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d4a862",
  null
  
)

export default component.exports